import React from 'react';
import { useBanners } from '../../hooks/useBanners';
import { getImageUrl } from '../../utils/getImageUrl';

const HeaderBannerDisplay = ({
  location = 'homepage',
  section = 'header',
  userType = 'all',
  height = '80px',
  showLoadingSpinner = false,
  className = ''
}) => {
  const { banners, loading, error, handleBannerClick } = useBanners(
    location,
    section,
    userType,
    {
      autoTrackImpressions: true,
      onBannerClick: null
    }
  );

  const [visibleStates, setVisibleStates] = React.useState({});

  React.useEffect(() => {
    if (banners?.length) {
      const newState = {};
      banners.forEach(b => {
        newState[b._id] = true;
      });
      setVisibleStates(newState);
    }
  }, [banners]);

  const handleHide = (id) => {
    setVisibleStates(prev => ({ ...prev, [id]: false }));
  };

  const visibleBanners = banners?.filter(b => visibleStates[b._id]);

  if (loading && showLoadingSpinner) {
    return (
      <div style={{ width: '100vw', textAlign: 'center', padding: '10px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading banners...</span>
        </div>
      </div>
    );
  }

  if (error || !visibleBanners?.length) return null;

  return (
    <div
      className={`header-banner-wrapper ${className}`}
      style={{
        width: '100vw',
        marginLeft: 'calc(-50vw + 50%)',
        overflow: 'hidden',
        position: 'relative'
      }}
    >
      {visibleBanners.map((banner) => (
        <HeaderBannerItem
          key={banner._id}
          banner={banner}
          height={height}
          onClick={handleBannerClick}
          onClose={() => handleHide(banner._id)}
        />
      ))}
    </div>
  );
};


const HeaderBannerItem = ({ banner, height, onClick, onClose }) => {
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const [imageError, setImageError] = React.useState(false);

  if (imageError) return null;

  return (
    <div
      className="header-banner-item"
      style={{
        height,
        width: '100vw',
        position: 'relative',
        cursor: 'pointer',
        overflow: 'hidden'
      }}
      onClick={() => onClick(banner)}
    >
      {banner.image?.url && !imageError && (
        <img
          src={getImageUrl(banner.image.url)}
          alt={banner.title}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageError(true)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            display: imageLoaded ? 'block' : 'none'
          }}
        />
      )}

      {!imageLoaded && (
        <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="spinner-border text-secondary" role="status">
            <span className="visually-hidden">Loading image...</span>
          </div>
        </div>
      )}

      <button
        onClick={(e) => {
          e.stopPropagation();
          onClose?.(); // Call parent onClose
        }}
        style={{
          position: 'absolute',
          top: 8,
          right: 12,
          background: 'rgba(255,255,255,0.9)',
          border: 'none',
          borderRadius: '50%',
          width: 28,
          height: 28,
          fontSize: 18,
          cursor: 'pointer',
          zIndex: 2
        }}
        title="Close"
      >
        ×
      </button>
    </div>
  );
};


export default HeaderBannerDisplay;
